module.exports = __webpack_public_path__ + "public/Icons/mainSite.svg?05cdb9d1";